export async function defaultValues() {
    const url = ('https://marketing.cmgfi.com/calculator-api/default-values');
    const result = await fetch(url)
        .then(response => response.json());
    const parsedValues = JSON.parse(result);
    return parsedValues;
};
